import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./Responsive.css";
import Login from "./Auth/Login";
import Invest from "./Components/Invest";
import CardSlider from "./Components/CardSlider";
import Filter from "./Components/Filter";
import ListView from "./Components/ListView";
import InvestDetails from "./Components/InvestDetails";
import CheckScam from "./Components/CheckScam";
import SideNavbar from "./Components/SideNavbar";
import NewPools from "./Components/NewPools";
import Header from "./Components/Header";
import DetailView from "./Components/DetailView";
import Home from "./Auth/Home";
// *****************Central Exchange*********************
import CentralCard from "./CenteralExchange/CentralCard";
import ActiveCoin from "./Components/ActiveCoin";
import UpcomingCoin from "./Components/UpcomingCoin";
import PrivateSale from "./Components/PrivateSale";
import DetailPS from "./Components/DetailPS";
// *********************My Fav***************************
import Favorites from "./CenteralExchange/Favorites";
// import AddNew from "./CenteralExchange/AddNew";
import { ToastContainer } from "react-toastify";
import DEX from "./CenteralExchange/DEX";
import FavPrivate from "./CenteralExchange/FavPrivate";
import NewDetail from "./CenteralExchange/NewDetail";
import ConnectModal from "./Connect Wallet/ConnectModal";
import WalletDetail from "./Connect Wallet/WalletDetail";
import History from "./Connect Wallet/History";
import Cex from "./CenteralExchange/Cex";
import Signup from "./Auth/Signup";
import Forget from "./Auth/Forget";
import Verification from "./Auth/Verification";
import ChangePassword from "./Auth/ChangePassword";
// Legal
import PrivacyPolicy from "./Legal/PrivacyPolicy";
import TermsAndConditions from "./Legal/TermsAndConditions";
// Profile
import Profile from "./Profile/Profile";
// Notification
import Notification from "./Notifications/Notification";
// Dynamic Header
import DynamicHeader from "./Header/DynamicHeader";
import TwoStepVerification from "./Auth/TwoStepVerification";
// Educational Section
import EducationalSection from "./Educational Section/EducationalSection";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { SocketProvider } from "./contexts/SocketContext";
import ErrorModal from "./Components/ErrorModal";

function App() {
  // Removed socket logic, now handled by SocketProvider
  const location = useLocation();
  const noSidebarPaths = [
    "/",
    "/signup",
    "/forgot-password",
    "/verification",
    "/change-password",
    "/connect-wal",
    "/check-scam",
    "/two-step-verification",
    // "/Education-Section"
  ];

  const showSidebar = !noSidebarPaths.includes(location.pathname);

  return (
    <SocketProvider>
      <ErrorModal />
      <div className="wrap-all">
        {/* ****************SideNavBar************** */}
        {showSidebar && <SideNavbar />}
        <Routes>
          <Route path="/connect-wal" element={<ConnectModal />} />
          <Route path="/Lookna-wallet" element={<WalletDetail />} />
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/home" element={<Home />} />
          {/*****************DEX**************/}
          <Route path="/DEX" element={<Invest />} />
          <Route path="/card" element={<CardSlider />} />
          <Route path="/filter" element={<Filter />} />
          <Route path="/listView" element={<ListView />} />
          <Route path="/details/:tokenaddress" element={<InvestDetails />} />
          <Route path="/newpools" element={<NewPools />} />
          <Route path="/detail-view" element={<DetailView />} />
          {/* ***************CheckScam****************** */}
          <Route path="/check-scam" element={<CheckScam />} />
          {/* *******************CEX***************** */}
          <Route path="/exchange" element={<CentralCard />} />
          <Route path="/watch-list" element={<Favorites />} />
          {/* ****************Private Sales***************/}
          <Route path="/private-sale" element={<PrivateSale />}></Route>
          <Route path="/active-coin" element={<ActiveCoin />}></Route>
          <Route path="/upcoming-coin" element={<UpcomingCoin />}></Route>
          <Route path="/PS-detail" element={<DetailPS />} />
          <Route path="/dexxxx" element={<DEX />} />
          <Route path="/newdetail/:tokenaddress" element={<NewDetail />} />
          <Route path="/history" element={<History />} />
          <Route path="/CEX" element={<Cex />} />
          <Route path="/Forgot-Password" element={<Forget />} />
          <Route path="/verification" element={<Verification />} />
          <Route
            path="/two-step-verification"
            element={<TwoStepVerification />}
          />
          <Route path="/change-password" element={<ChangePassword />} />
          {/*Legal */}
          <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
          <Route path="/Terms-and-Condition" element={<TermsAndConditions />} />
          {/* Profile */}
          <Route path="/Profile" element={<Profile />} />
          {/* Notification */}
          <Route path="/Notification" element={<Notification />} />
          {/* {Educational Section} */}
          <Route path="/Education-Section" element={<EducationalSection />} />
        </Routes>
        <ToastContainer />
      </div>
    </SocketProvider>
  );
}

export default App;
